// 全局顶部消息提示（TB-Message）统一入口
// 规范：src/components/common/1.html「3. 成功/失败/警告提示 (Message)」
// 用法：this.$tbMessage({ type: 'success' | 'error' | 'warning' | 'info', text: '文案', duration: 2000 })
//       this.$tbMessage({ type: 'success', text: '文案', actions: [{ text, primary, onclick }] })
//         —— 带操作按钮（1.html「成功提示（带操作）」样式），duration 默认 0 不自动消失 + showClose
//       tbMessage({ type, text, duration }) —— 无 this 上下文（如 axios 拦截器）时用
// 效果：顶部居中白色圆角卡片 + 46px 品牌色线性图标（图标在上）+ 文字，自动消失
// 背景：批次2「复制成功/失败」提示统一。所有复制提示统一走此方法，样式集中在 tb-feedback.less 的 .tb-custom-message。
import { Message } from "element-ui";

export default {
  install(Vue) {
    Vue.prototype.$tbMessage = function (opts = {}) {
      const type = opts.type || "success";
      const text = opts.text || "";
      const actions = opts.actions || [];
      if (!this || typeof this.$message !== "function") return;
      const hasActions = actions.length > 0;
      return this.$message({
        message: buildToastHtml(type, text, actions),
        type,
        customClass: "tb-custom-message",
        dangerouslyUseHTMLString: true,
        duration: opts.duration ?? (hasActions ? 0 : 2000),
        ...(opts.showClose || hasActions ? { showClose: true } : {}),
      });
    };
  },
};

// 无 this 上下文的独立调用（axios 拦截器等非组件环境）
export function tbMessage(opts = {}) {
  const type = opts.type || "success";
  const text = opts.text || "";
  const actions = opts.actions || [];
  const hasActions = actions.length > 0;
  return Message({
    message: buildToastHtml(type, text, actions),
    type,
    customClass: "tb-custom-message",
    dangerouslyUseHTMLString: true,
    duration: opts.duration ?? (hasActions ? 0 : 2000),
    ...(opts.showClose || hasActions ? { showClose: true } : {}),
  });
}

function buildToastHtml(type, text, actions) {
  const hasActions = actions && actions.length > 0;
  const actionHtml = hasActions
    ? `<div class="tb-toast-actions">${actions
        .map((a) => `<button class="tb-toast-btn${a.primary ? " tb-toast-btn--primary" : ""}" onclick="${a.onclick}">${a.text}</button>`)
        .join("")}</div>`
    : "";
  return (ICON_SVG[type] || ICON_SVG.success) + `<span${hasActions ? ' class="tb-toast-text"' : ""}>${text}</span>${actionHtml}`;
}

// 与设计稿一致的线性图标（stroke="currentColor"，颜色由 .el-message--success/error/warning 控制）
const ICON_SVG = {
  success:
    '<svg class="tb-toast-icon" width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="square" stroke-linejoin="miter"><circle cx="12" cy="12" r="10"></circle><path d="M 8.5 12.5 L 11 15 L 15.5 10.5"></path></svg>',
  error:
    '<svg class="tb-toast-icon" width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="square" stroke-linejoin="miter"><circle cx="12" cy="12" r="10"></circle><path d="M 14.5 9.5 L 9.5 14.5 M 9.5 9.5 L 14.5 14.5"></path></svg>',
  warning:
    '<svg class="tb-toast-icon" width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="square" stroke-linejoin="miter"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12.01" y2="8"></line><line x1="12" y1="12" x2="12" y2="16"></line></svg>',
  // 常规提示（非警告、非报错），颜色见 tb-feedback.less 的 .el-message--info
  info:
    '<svg class="tb-toast-icon" width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="square" stroke-linejoin="miter"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>',
};
